export const formatPrice = (plan, currency) => {
  if (!plan) return "";
  const amount = currency === "inr" ? plan.price_inr : plan.price_usd;
  const symbol = currency === "inr" ? "₹" : "$";
  const locale = currency === "inr" ? "en-IN" : "en-US";
  return `${symbol}${Number(amount).toLocaleString(locale, { maximumFractionDigits: 0 })}`;
};

export const formatAmount = (amount, currency) => {
  const symbol = currency === "inr" ? "₹" : "$";
  const locale = currency === "inr" ? "en-IN" : "en-US";
  return `${symbol}${Number(amount).toLocaleString(locale, { maximumFractionDigits: 2 })}`;
};
